import styled from 'styled-components';
import { StateHintContainer } from '../StateHint/styles';

export const UnitHintContainer = styled(StateHintContainer)`
  height: 100px;
  flex-direction: row;
  gap: 8px;

  @media (min-width: 1024px) and (max-width: 1440px) {
    width: 200px;

    & > span {
      font-size: 8px;
    }
  }
`;
